module.exports = __webpack_public_path__ + "static/img/Image_014.ebe3787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_014.jpg
// module id = 7uow
// module chunks = 3